var exports = {
  "p$": "ResizablePaneHandles.module__handle___TVBaMT",
  "J3": "ResizablePaneHandles.module__edgeTop___TVBaMT",
  "xf": "ResizablePaneHandles.module__edgeBottom___TVBaMT",
  "Ve": "ResizablePaneHandles.module__edgeLeft___TVBaMT",
  "IW": "ResizablePaneHandles.module__edgeRight___TVBaMT",
  "wy": "ResizablePaneHandles.module__cornerTopLeft___TVBaMT",
  "Ty": "ResizablePaneHandles.module__cornerTopRight___TVBaMT",
  "AU": "ResizablePaneHandles.module__cornerBottomLeft___TVBaMT",
  "pr": "ResizablePaneHandles.module__cornerBottomRight___TVBaMT",
};

module.exports = exports;
